function Footer() {
  return (
    <footer className="footer">
      © {new Date().getFullYear()} Lune Livings. All rights reserved.
    </footer>
  );
}

export default Footer;
